import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {MalFunctionKind} from '../model/malfunction-kind';
import {ApiService} from '../api.service';
import {Location} from '../model/location';
import {catchError} from "rxjs/internal/operators";
import {NameFormatter} from '../util/name-formatter';
import {MapRefreshService} from '../map-refresh.service';

@Component({
  selector: 'app-report-malfunction',
  templateUrl: './report-malfunction.component.html',
  styleUrls: ['./report-malfunction.component.scss']
})
export class ReportMalfunctionComponent implements OnInit {

  loading = true;

  email: string = "";
  firstName: string = "";
  lastName: string = "";
  phoneNumber: string = "";

  description: string = "";
  descriptionMaxLength: number = 250;

  malfunctionKindId: string = null;

  malfunctionKinds: MalFunctionKind[];

  emailError = false;
  malfunctionKindError = false;

  location: Location;

  userNotified: boolean = true;

  sentComplete = false;
  errorDuringSent = false;

  constructor(private router: Router, protected apiService: ApiService, private route: ActivatedRoute, private nameFormatter: NameFormatter, protected mapRefreshService: MapRefreshService) { }

  ngOnInit() {
    this.apiService.get('malfunction-kinds').subscribe((malfunctionKinds: MalFunctionKind[]) => {
      this.malfunctionKinds = malfunctionKinds.sort(function (a, b) {
        const textA = a.description.toUpperCase();
        const textB = b.description.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });

      this.checkAndHandleInitFinish();
    })

    this.apiService.get(`locations/${this.route.snapshot.paramMap.get("id")}`).pipe(catchError((err, caught) => {
      return this.apiService.get(`locations/name-ends-with/${this.route.snapshot.paramMap.get("id")}`)
    })).subscribe((location: Location) => {
      this.location = location;
      this.checkAndHandleInitFinish();
    })
  }

  checkAndHandleInitFinish() {
    if (this.malfunctionKinds && this.location) {
      this.loading = false;
    }
  }

  goBack() {
    this.router.navigateByUrl('/');
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validateErrors() {
    this.malfunctionKindError = !this.malfunctionKindId;
    this.emailError = this.userNotified && !this.validateEmail(this.email);
  }

  onSubmit() {
    this.validateErrors();

    if (this.malfunctionKindError || this.emailError) {
      return;
    }

    this.loading = true;

    if (!this.emailError && !this.malfunctionKindError) {

      if (!this.userNotified) {
        this.email = "";
        this.firstName = "";
        this.lastName = "";
        this.phoneNumber = "";
      }

      this.apiService.post('report-malfunction', {
        locationRefererId: this.location.refererId,
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber,
        malfunctionkindId: this.malfunctionKindId,
        description: this.description
      }).pipe(catchError((err, caught) => {
        this.errorDuringSent = true;
        this.loading = false;
        throw err;
      })).subscribe(result => {
        this.loading = false;
        this.sentComplete = true;
        this.mapRefreshService.refresh();
      });
    }
  }
}
